<template>
    <span class="count">
        <b>
            {{ $t('registration.flight-suggestions-count-1') }}
            <template v-if="searchSuggestion">
                <div class="lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </template>
            <template v-else>
                {{ nbSuggestion }}
            </template>
            {{ $t('registration.flight-suggestions-count-2') }}
        </b>
        <template v-if="!searchSuggestion && nbSuggestion > 0">
            <font size="3">{{ $t('registration.flight-suggestions-alt', {
                price: parseInt(suggestionMinPrice.totalPriceHt),
                nbPassenger: suggestionMinPrice.nbPassengers
            }) }}</font>
        </template>
    </span>
</template>
<script>
export default {
    name: "SuggestionPlanes",
    props: {
        fromAirport: {
            type: Object
        },
        toAirport: {
            type: Object
        }
    },
    data() {
        return {
            searchSuggestion: true,
            planesSuggestions: []
        }
    },
    mounted() {
        axios.get("/registration/compute-flight-suggestions")
        .then(({ data }) => {
            this.planesSuggestions = data;
            this.searchSuggestion = false;
        })
        .catch(
            ({
                response: {
                    data: { errors }
                }
            }) => {}
        );
    },
    computed: {
        nbSuggestion() {
            return this.planesSuggestions.length;
        },
        suggestionMinPrice() {
            var minPrice = 0;
            var suggestion = null;
            this.planesSuggestions.forEach(element => {
                if (minPrice == 0 || minPrice > element.totalPriceHt) {
                    minPrice = parseInt(element.totalPriceHt);
                    suggestion = element;
                }
            });
            return suggestion;
        },
    }
}
</script>
<style lang="scss" scoped>
@import '~styles/_variables';
.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 12px;
}
.lds-ellipsis div {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: $primary-color;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}
@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(24px, 0);
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/registration/Profile/suggestion-planes.vue